import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Product} from 'src/app/product-details/interface/product';
import {VolumeDiscountProfileItem} from 'src/app/product-details/interface/volume-discount-profile-item';

@Injectable({
	providedIn: 'root'
})
export class PreOrderVolumeDiscountCalculationService {

	constructor() { }

	public passedVolumeDiscount: Subject<VolumeDiscountProfileItem> = new Subject<VolumeDiscountProfileItem>;

	public calculatePreOrderVolumeDIscountPrice(price: number, qty: number, productData: Product): number {

		let passedVolumeDIscount: VolumeDiscountProfileItem = {} as VolumeDiscountProfileItem;

		let sorterdVolumeDiscountItem: VolumeDiscountProfileItem[] =
			productData.volumeDiscountProfile!.volumeDiscountProfileItemList.filter(
				(discount: VolumeDiscountProfileItem) => discount.preOrder
			).sort(
				(a: VolumeDiscountProfileItem, b: VolumeDiscountProfileItem) => a.minimumOrderQuantity - b.minimumOrderQuantity
			); //sorting


		for (let i = 0; i < sorterdVolumeDiscountItem.length; i++) {

			let minDiscount = sorterdVolumeDiscountItem[i].minimumOrderQuantity;
			let maxDiscount =
				!sorterdVolumeDiscountItem[i + 1] ? minDiscount + 10000 : sorterdVolumeDiscountItem[i + 1].minimumOrderQuantity;

			if (
				qty < minDiscount
			) { //if quantity less than vs quantity

				passedVolumeDIscount = {} as VolumeDiscountProfileItem;
				break

			}
			// debugger
			if (qty >= minDiscount && qty <= (maxDiscount - 1)) {

				if (sorterdVolumeDiscountItem.length < 2) {
					passedVolumeDIscount = sorterdVolumeDiscountItem[0];
					break
				}
				else {
					passedVolumeDIscount = sorterdVolumeDiscountItem[i];
					break
				}


			}

		}

		// console.log(passedVolumeDIscount);
		// console.log(this._discountCalculation(price, passedVolumeDIscount.discount));
		if (passedVolumeDIscount.discount) {
			this.passedVolumeDiscount.next(passedVolumeDIscount);
		}


		return this._discountCalculation(price, passedVolumeDIscount.discount)
	}


	private _discountCalculation(amount: number, discountPercentage: number): number {

		const discount = (discountPercentage / 100) * amount;
		const discountedAmount = amount - discount;
		return discountedAmount;

	}

	public preorderEstimateDeliveryDateCalc(day: number): number {

		const today = new Date();

		const estimatedDeliveryDate = new Date(today);
		estimatedDeliveryDate.setDate(today.getDate() + day);

		const estimatedDeliveryEpochTime = estimatedDeliveryDate.getTime();

		return estimatedDeliveryEpochTime;
	}
}
